import styled from '@emotion/styled';
import { Popover, PopoverProps } from 'antd';
import { useTranslate } from '@tolgee/react';
import moreSvg from '../assets/more.svg';

export const Trigger = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  > img {
    width: 16px;
    height: 16px;
    margin-left: 6px;
  }
`;

const List = styled.ul`
  max-width: 325px;
  max-height: 200px;
  margin: -12px -16px;
  padding: 12px 16px;
  list-style: none;
  overflow-x: hidden;
  overflow-y: auto;
  > li {
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export interface Store {
  id: string | number;
  storeName: string;
  alias: string;
  isStoreAliasFirst?: boolean;
}

export interface StoreListProps extends PopoverProps {
  isStoreAliasFirst?: boolean;
  storeList: Store[];
}

function StoreList(props: StoreListProps) {
  const { isStoreAliasFirst: isStoreAliasFirstProp = true, storeList } = props;

  const { t } = useTranslate();

  if (storeList.length === 0) {
    return <Trigger>{t('aide.x 个店铺', { x: storeList.length })}</Trigger>;
  }

  const list = (
    <List>
      {storeList.map(({ id, alias, storeName, isStoreAliasFirst = isStoreAliasFirstProp }) => {
        return <li key={id}>{isStoreAliasFirst ? alias || storeName : storeName}</li>;
      })}
    </List>
  );

  return (
    <Popover placement="bottom" content={list}>
      <Trigger>
        {t('aide.x 个店铺', { x: storeList.length })}
        <img src={moreSvg} alt="more" />
      </Trigger>
    </Popover>
  );
}

export default StoreList;
